import React, { useContext } from 'react'
import WorkItemData from '@Components/WorkItemV2/work-item-data'
import ExtendedWorkItem from '@Components/WorkItemV2/ExtendedWorkItem'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import ShareDisplay from '@Components/WorkItemV2/ShareDisplay'
import { getSourceNameBySourceId } from '@App/helpers/work-entities/utils/get-source-name-by-source-id'
import { getSubmissionPath } from '@App/helpers/get-submission-path'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import './index.scss'
import NeedsAttentionActions from '@Components/WorkItemV2/History/NeedsAttentionActions'
import { observer } from 'mobx-react'

const NeedsAttentionExtendedWorkItem = ({ work, fetchType }: WorkItemData) => {
    const { rightsholderStore } = useContext<RootStore>(StoresContext)

    const submissionDate =
        work.submissionDate &&
        new Date(work.submissionDate).toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        })

    const submissionPath = getSubmissionPath(rightsholderStore.currentRightsholderId, work.id, fetchType)

    return (
        <div className="needs-attention-extended-work-item-wrapper">
            <ExtendedWorkItem
                work={work}
                fields={[
                    { title: 'Submission Date', value: submissionDate },
                    { title: 'Submission Source', value: getSourceNameBySourceId(work?.sourceId) },
                    { title: 'ISWC', value: work.iswc },
                    { title: 'Member Work Identifier', value: work.rightsholderProprietaryId },
                ]}
                catalogPath={submissionPath}
                bottomFields={
                    work.rejectionReason
                        ? [{ title: 'Rejection Reason', value: work.rejectionReason, className: 'rejection-reason' }]
                        : undefined
                }
                showOverclaimTooltip
            >
                <ShareDisplay
                    share={work.totalKnownShares}
                    highlight
                    tooltip={
                        <CustomToolTip
                            title="Your Total Submitted Shares:"
                            info={
                                'This reflects total shares you have submitted to The MLC. ' +
                                'These submitted shares are subject to review and approval by The MLC before being processed.'
                            }
                        />
                    }
                />
                <NeedsAttentionActions work={work} />
            </ExtendedWorkItem>
        </div>
    )
}

export default observer(NeedsAttentionExtendedWorkItem)
